import { useQuery } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useCurrentJobId } from "@/hooks/useCurrentJobId";
import { guacHttpClient } from "@/lib/http";
import { HttpResponse, JobUpdate } from "@/types";

export function useGetJobDifficultyUrgencies() {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();

  return useQuery({
    queryKey: ["job-difficulty-urgencies", currentCompanyId, currentJobId],
    queryFn: async () => {
      const path = `companies/${currentCompanyId}/jobs/${currentJobId}/job-difficulty-urgencies`;
      const res = await guacHttpClient.get<
        JobUpdate[],
        HttpResponse<JobUpdate[]>
      >(path);
      return res.data;
    },
});
}
